module.exports = __webpack_public_path__ + "static/media/Unirac_black.c23c071a.png";